import { render, staticRenderFns } from "./border-header.vue?vue&type=template&id=184b1e0e&scoped=true&"
import script from "./border-header.vue?vue&type=script&lang=js&"
export * from "./border-header.vue?vue&type=script&lang=js&"
import style0 from "./border-header.vue?vue&type=style&index=0&id=184b1e0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b1e0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('184b1e0e')) {
      api.createRecord('184b1e0e', component.options)
    } else {
      api.reload('184b1e0e', component.options)
    }
    module.hot.accept("./border-header.vue?vue&type=template&id=184b1e0e&scoped=true&", function () {
      api.rerender('184b1e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/government/sm-union/components/border-header.vue"
export default component.exports